import UrlService from '../../../services/UrlService';
import axiosActions from '../axiosHelpers';
import { getSelectedCompany } from '../../selectors';
import { uuidv4 } from '../../../utils/uuid';

export const FETCH_VEHICLE_DRIVING_TIME = axiosActions('VEHICLE_DRIVING_TIME_LOAD');

export const fetchVehicleDrivingTime = (vehicleId) => (dispatch, getState) => {
  const selectedCompany = getSelectedCompany(getState());
  return dispatch({
    type: FETCH_VEHICLE_DRIVING_TIME.START,
    payload: {
      actionId: uuidv4(),
      request: {
        url: UrlService.vehicleDrivingTime(selectedCompany, vehicleId),
      },
    },
  });
};
